import { MutableRefObject, useEffect } from 'react';

/**
 * This simple hook is designed to apply an event listener on the document and when that event fires,
 * if the event occured OUTSIDE of the ref provided to the hook, the hook will execute the user supplied
 * callback function. It also will cleanup the event listener when the component calling the hook unmounts.
 *
 * @param eventType  Event type to use i.e. 'mousedown', 'click' etc.
 * @param refs       List of element refs that we want to verify were not the target of the event
 * @param callback   callback to fire if the event was outside of the given element ref
 */
export const useOutsideEvent = (
  eventType: string,
  refs: Array<MutableRefObject<HTMLElement | null>>,
  callback: Function,
): void => {

  const handleEvent = (e: Event): void => {
    if (!refs.some((ref) => ref?.current && ref?.current?.contains(e.target as Node))) {
      callback();
    }
  };

  // Handle outside event
  useEffect(() => {
    document.addEventListener(eventType, handleEvent, { capture: true });

    // Cleanup listener
    return (): void => {
      document.removeEventListener(eventType, handleEvent, { capture: true });
    };
  });
};
